"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
let BlackListRequestController = class extends Mixins(
  AccountSessionMixins
) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/application_handler_list")
    );
    this.searchStr = "";
    this.searchStr_dates = {};
    this.searchStatus = {
      status: "blacklist"
    };
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = {
          applicant: searchStr
        };
        this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchAllData = _.debounce(() => {
      this.gridController.query.current = 1;
      this.gridController.query.filter = this.searchStatus;
      if (this.searchStr_dates && this.searchStr_dates !== null) {
        let obj = __spreadValues(__spreadValues({}, this.searchStatus), this.searchStr_dates);
        this.gridController.query.filter = obj;
      }
      this.gridController.search();
    }, 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.filter = this.searchStatus;
      this.gridController.search();
    });
  }
  refresh() {
    this.gridController.search();
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  itemDelete(rows) {
    try {
      let ids = _.map(rows, "application_guid");
      this.$confirm(
        this.$t(
          "safetyblacklist.this_operation_will_permanently_delete_this_authorization_request"
        ),
        this.$t("safetyblacklist.prompt"),
        {
          confirmButtonText: this.$t("safetyblacklist.delete"),
          cancelButtonText: this.$t("safetyblacklist.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        const response = yield API.delete(
          `api://base.auth/api/v7/handle/${ids[0]}`
        );
        this.$message.success(
          this.$t("safetyblacklist.delete_successful")
        );
        this.refresh();
      })).catch(() => {
        return;
      });
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
};
BlackListRequestController = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], BlackListRequestController);
export {
  BlackListRequestController as default
};
